import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20pattern%20with%20warm%20golden%20amber%20glowing%20squares%20floating%20in%20space%2C%20clean%20cream%20background%2C%20modern%20flat%20design%2C%20number%20puzzle%20game%20aesthetic%2C%20soft%20ambient%20lighting%2C%20elegant%20composition%2C%204K%20quality%2C%20no%20text&width=1600&height=900&seq=hero-bg-2048&orientation=landscape"
          alt="2048核基地 - 策略挑战中心"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            2048核基地
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-2 leading-relaxed">
            终极策略挑战中心
          </p>
          <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto leading-relaxed">
            专为2048深度玩家打造的策略攻略平台，提供最强合并技巧、核心玩法解析、高分路线图及进阶秘籍
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/hexin-wanfa"
              className="px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap"
            >
              开始学习
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-7 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-lg text-sm backdrop-blur-sm transition-colors whitespace-nowrap"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}